import { APIField } from "server/services/tables/types/fields";
import { APIRecord } from "server/services/tables/types/records";
import { Modal, ModalHeader } from "blocks/components/Modal";
import { TableRecordForm } from "blocks/components/TableRecordForm";
import { Text } from "blocks/components/Text";

type FormData = Record<string, any>;

export function ModalEditTableRecord(props: {
  newRecordButtonCopy?: string;
  fields: APIField[];
  record: APIRecord | undefined;
  onSubmit: (data: FormData) => void;
  isSubmitting?: boolean;
  onClosed: () => void;
  tableId: string | undefined;
}) {
  const isNew = !props.record;
  const newRecordButtonCopy = props.newRecordButtonCopy
    ? props.newRecordButtonCopy
    : "New record";
  return (
    <Modal onClosed={props.onClosed}>
      <ModalHeader>
        <Text as="div" type="modalTitle">
          {isNew ? newRecordButtonCopy : "Edit record"}
        </Text>
      </ModalHeader>
      <TableRecordForm
        fields={props.fields}
        record={props.record}
        onSubmit={props.onSubmit}
        isSubmitting={props.isSubmitting}
        onCancel={props.onClosed}
        tableId={props.tableId}
      />
    </Modal>
  );
}
